<template>
  <div class="video_baseFormBox">
    <div class="baseFormBox_label"><span class="require" v-if="options.require"
        :class="{requireMsg :options.value}">*</span>{{options.label}}</div>
    <div class="baseFormBox_data">
      <div @click="showForm" class="city_base">
        <div v-if='options.value&&options.value[0]'>
          {{options.value[0]+'/'+options.value[1]+'/'+options.value[2]}}
        </div>
        <div class="city_noData" v-if='!options.value||!options.value[0]'>{{options.placeholder||'请选择'}}</div>
      </div>
    </div>
    <slot></slot>

    <van-popup v-model="show" round position="bottom" :style="{ height: '310px' }">
      <div class="AR_select_cityF">
        <van-area @confirm='cityConfirm' @cancel='cityCancel' :area-list="areaList" />
      </div>
    </van-popup>
  </div>
</template>

<script> 

import { areaList } from "@vant/area-data";
export default {
  data() {
    return {
      areaList,
      show: false,
      form: {},
    };
  },
  methods: {
    showForm() {
      this.show = true;
    },
    cityConfirm(e) {
      console.log(e);
      console.log(this.cityModel);
      let arrList = []
      for (let i = 0; i < e.length; i++) {
        arrList.push(e[i].name)
      }
      this.options.value = arrList; //赋值 
      this.show = false; //关闭弹窗
    },
    cityCancel(e) {
      this.options.value = []; //赋值
      this.show = false; //关闭弹窗
    },
  },
  props: ['options', "index"],
};
</script> 
<style>
.baseFormBox_data .ant-cascader-picker {
  width: 100%;
}
.city_base {
  flex: 1;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  line-height: 36px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-radius: 4px;
  height: 36px;
  font-weight: 400;
  font-size: 14px;
  padding: 0 11px;
}
.city_noData {
  color: #c3c3c1;
}
</style>